import React from 'react';
import * as PropTypes from 'prop-types';
import cn from 'classnames';
import SmartViewMobile from './SmartViewMobile';
import SmartViewDesktop from './SmartViewDesktop';

const SmartNavigationMenu = (props) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);

  const openMobileMenu = (value) => {
    setIsMobileMenuOpen(value);
    if (value) {
      document.body.classList.add('block-overflow');
    } else {
      document.body.classList.remove('block-overflow');
    }
  };

  const focusOnSearchInput = () => {
    const searchInput = document.querySelector(
      'div.navigation-menu-mbl__body > form > div > div > input'
    );
    if (searchInput) {
      searchInput.focus();
    }
  };

  const hamburgerClasses = cn('hamburger', {
    'hamburger--transparent': props.isTransparent,
    'hamburger--absolute': props.isAbsolute,
  });

  return (
    <React.Fragment>
      <div className={hamburgerClasses} onClick={() => openMobileMenu(true)}>
        <span />
        <span />
        <span />
      </div>

      <SmartViewDesktop
        ignoredCategories={props.ignoredCategories}
        prefixesAreVisible={props.prefixesAreVisible}
      />

      {/* <SmartViewMobile isOpen={isMobileMenuOpen} onClickClose={() => openMobileMenu(false)} /> */}
    </React.Fragment>
  );
};

SmartNavigationMenu.propTypes = {
  isTransparent: PropTypes.bool.isRequired,
  isAbsolute: PropTypes.bool.isRequired,
  prefixesAreVisible: PropTypes.string,
};

SmartNavigationMenu.defaultProps = {
  isTransparent: false,
  isAbsolute: false,
};

SmartNavigationMenu.sanitizeProps = (props) => ({
  ...props,
  isTransparent: props.isTransparent === 'true',
  isAbsolute: props.isAbsolute === 'true',
});

export default SmartNavigationMenu;
